import { css } from "@linaria/core"
import { styled } from "@linaria/react"

import { Horizontal } from "@/components/Flex.ts"
import { inputBaseStyles, inputFocusStyles, inputHoverStyles } from "@/styles/inputMixins.ts"
import { focusOutline } from "@/styles/mixins.ts"

const Disabled = css`
  pointer-events: none;
  background: var(--text-color-5-opaque);
  border-color: var(--text-color-5-opaque);

  & > * {
    opacity: 0.6;
  }
`

export const PromptInputStyles = {
  Disabled,

  Highlighted: css`
    border-color: var(--main-color);
    background-color: var(--main-color-5-opaque);
    box-shadow: 0 0 0 2px var(--main-color-20) inset;
    animation: highlight-pulse 1s ease-out;

    @keyframes highlight-pulse {
      0% {
        box-shadow: 0 0 0 2px var(--main-color-20) inset;
      }

      50% {
        box-shadow: 0 0 0 4px var(--main-color-30) inset;
      }

      100% {
        box-shadow: 0 0 0 2px var(--main-color-20) inset;
      }
    }
  `,

  Pulsing: css`
    border-color: var(--success-color);
    background-color: var(--main-color-5-opaque);
    box-shadow: 0 0 0 2px var(--success-color-10) inset;
    animation: highlight-pulse 1s ease-out;

    @keyframes highlight-pulse {
      0% {
        box-shadow: 0 0 0 2px var(--success-color-20) inset;
      }

      50% {
        box-shadow: 0 0 0 4px var(--success-color-30) inset;
      }

      100% {
        box-shadow: 0 0 0 2px var(--success-color-20) inset;
      }
    }
  `,

  Shaking: css`
    animation: shake 0.3s ease-in-out;

    @keyframes shake {
      0%, 100% { transform: translateX(0); }
      20%, 60% { transform: translateX(-4px); }
      40%, 80% { transform: translateX(4px); }
    }
  `,

  SingleLine: css`
    padding: 20px 16px !important;
    line-height: 24px;
  `,

  Container: css`
    ${inputBaseStyles};
    border-radius: var(--border-radius-20);
    z-index: 1;

    &:focus-within:not(:has(.${Disabled})) {
      ${inputFocusStyles};
    }

    &:hover:not(:focus-within, :has(.${Disabled})) {
      ${inputHoverStyles};
    }
  `,

  Input: css`
    font: inherit;

    width: 100%;
    min-height: 24px;
    max-height: min(30vh, 600px);
    margin: 0;
    padding: 0;

    background: transparent;

    resize: none;
    outline: none;

    color: var(--text-color);

    &::placeholder {
      color: var(--secondary-text-color);

      user-select: none;
    }
  `,

  FooterIconContainer: styled(Horizontal)`
    align-items: center;
    justify-content: center;

    width: 24px;
    height: 24px;

    cursor: pointer;

    color: var(--secondary-text-color);
    transition: color 0.2s ease-out, transform 0.1s ease-out;

    user-select: none;

    &:active {
      transform: scale(0.95);
    }

    &:hover:not(:disabled) {
      color: var(--text-color);
      transform: scale(1.05);

      .svg-icon {
        color: var(--text-color);
      }
    }

    &:focus-visible {
      ${focusOutline};
    }
  `
}